import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import "./footer.css";
import Modal2 from "../Modal2";

import { useAnimation, motion, useInView } from "framer-motion";

const Footer = () => {
  const ref = useRef(null);
  const location = useLocation();
  const isInView = useInView(ref, { once: true });

  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView]);

  const navigate = useNavigate();

  const handleLinkClick = (link) => {
    navigate(link); // Navigate to the specified link
    window.location.reload(); // Refresh the page
  };

  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const { pathname } = location;

  const isRouteActive = (targetRoute) => pathname === targetRoute;

  return (
    <div ref={ref} className="footer_container">
    <div className="footer_line_container"><div className="footer_line"></div></div>
      
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 120 },
          visible: { opacity: 1, y: 0 },
        }}
        className="footer_div1"
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        <div className="footer_div11">
          <span>Follow us on</span>
          <a
            target="_blank"
            href="https://www.linkedin.com/company/crestdigitel/"
          >
            <img src="/assets/Linkedin.png" alt="" width={40} />
          </a>
          <a target="_blank" href="https://www.youtube.com/@CrestDigitel">
            <img src="/assets/yt_icon.png" alt="" width={40} />
          </a>
        </div>
      </motion.div>
      <div className="footer_flex2">

      <motion.div
        variants={{
          hidden: { opacity: 0, y: 120 },
          visible: { opacity: 1, y: 0 },
        }}
        className="footer_div2"
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        <div className="footer_div21">
          <h4>Who We Are</h4>
          <ul>
            <Link to="/about-us"    className={isRouteActive('/about-us') ? 'active1' : ''}>
              {" "}
              <li>About Us</li>
            </Link>
            <Link to="/leadership"   className={isRouteActive('/leadership') ? 'active1' : ''} >
              <li>Leadership</li>
            </Link>
            <Link to="/our-portfolio"  className={isRouteActive('/our-portfolio') ? 'active1' : ''}>
              <li>Our Portfolio</li>
            </Link>

            <Link to="/our-operations"  className={isRouteActive('/our-operations') ? 'active1' : ''}>
              <li>Our Operations</li>
            </Link>

            <Link
              to="/our-marquee-deployment"
         
              className={isRouteActive('/our-marquee-deployment') ? 'active1' : ''}
            >
              <li>Our Marquee Deployments</li>
            </Link>

            <Link to="/our-values" className={isRouteActive('/our-values') ? 'active1' : ''}>
              <li>Our Values</li>
            </Link>
          </ul>
        </div>
        <div className="footer_div21">
          <h4>Our Culture</h4>
          <ul>
            <Link to="/life-at-crest"  className={isRouteActive('/life-at-crest') ? 'active1' : ''}>
              <li>Life At Crest</li>
            </Link>
          </ul>
        </div>
        <div className="footer_div21">
          <h4>Investors Relations</h4>
          <ul>
            <Link to="/announcement"  className={isRouteActive('/announcement') ? 'active1' : ''}>
              <li>Announcements</li>
            </Link>

            <Link to="/codes-policies"  className={isRouteActive('/codes-policies') ? 'active1' : ''}>
              <li>Codes and Policies</li>
            </Link>
          </ul>
        </div>
        <div className="footer_div21">
          <h4>Our Partners</h4>
          <ul>
            <Link to="/our-partners"  className={isRouteActive('/our-partners') ? 'active1' : ''}>
              <li>Our Partners</li>
            </Link>
          </ul>
        </div>
        <div className="footer_div21" >
          <h4>Media</h4>
          <ul>
            <Link  to="/newsroom" className={isRouteActive('/newsroom') ? 'active1' : ''}>
              <li>Newsroom</li>
            </Link>
          </ul>
        </div>
        <div className="footer_div21">
          <h4>CSR</h4>
          <ul>
            <Link to="/our-initiatives"  className={isRouteActive('/our-initiatives') ? 'active1' : ''}>
              <li>Our Initiatives</li>
            </Link>
          </ul>
        </div>
        <div className="footer_div21">
          <h4>Awards & Recognitions</h4>
          <ul>
            <Link
              to="/awards-and-recognitions"
              className={isRouteActive('/awards-and-recognitions') ? 'active1' : ''}
            >
              <li>Awards & Recognitions</li>
            </Link>
          </ul>
        </div>
        <div className="footer_div21">
          <h4>Get In Touch</h4>
          <ul>
            <Link to="/get-in-touch"  className={isRouteActive('/get-in-touch') ? 'active1' : ''}>
              <li>Contact Us</li>
            </Link>

            <Link to="/careers"  className={isRouteActive('/careers') ? 'active1' : ''}>
              <li>Careers</li>
            </Link>
          </ul>
        </div>
      </motion.div>
      </div>

      <div className="footer_flex">
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 120 },
            visible: { opacity: 1, y: 0 },
          }}
          className="footer_div3"
          initial="hidden"
          animate={mainControls}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <img src="/assets/Footer.svg" alt="" />
        </motion.div>
        
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 120 },
            visible: { opacity: 1, y: 0 },
          }}
          className="footer_div4"
          initial="hidden"
          animate={mainControls}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <span>Crest Digitel Private Limited</span>
          <span style={{ fontWeight: 300 }}>
            (Formerly Space Teleinfra Private Limited)
          </span>
        </motion.div>
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 120 },
            visible: { opacity: 1, y: 0 },
          }}
          className="footer_div5"
          initial="hidden"
          animate={mainControls}
          transition={{ duration: 0.5, delay: 0.7 }}
        >
          <span>
            © Crest Digitel 2022 |
            <Link to='/privacy-policy' className={isRouteActive('/privacy-policy') ? 'active1' : 'dislink'}>
            Privacy Policy
            </Link> |
            <Link className="dislink" onClick={openModal} >
              Disclaimer
            </Link>{" "}
          </span>
        </motion.div>
      </div>

      {modalOpen && <Modal2 closeModal={closeModal} />}
    </div>
  );
};

export default Footer;
